import { render, staticRenderFns } from "./export-teams-modal.vue?vue&type=template&id=16031436&"
import script from "./export-teams-modal.vue?vue&type=script&lang=js&"
export * from "./export-teams-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports